import theme from '@css/theme';
import styled from 'styled-components';

export const Circle = styled.div<{ selected: boolean }>`
  height: 8px;
  width: 8px;
  border-radius: 4px;
  background: ${({ selected }) => (selected ? theme.color.rsPrimary : theme.color.border)};
  margin-right: 8px;
  &:last-child {
    margin-right: 0;
  }
`;

export const PopupContainer = styled.div`
  border: 1px solid ${theme.color.border};
  border-radius: 4px;
`;
